// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"f981b825","359":"057a6063","442":"6ccbfedb","607":"da7b117a"}[chunkId] + ".chunk.js";
};